export enum PropertyStatus {
  Draft = 'Draft',
  LivePrivate = 'LivePrivate',
  LivePublic = 'LivePublic',
  Suspended = 'Suspended',
}
